import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {adminRequest, buildQuery} from "../../api/adminApi";

const initialState = {
  users: [] as any[],
  permissions: [] as any[],
  loading: false,
  error: undefined as string | undefined,
};

export const getAdminUsers = createAsyncThunk<any[], string | {token: string; searchParam?: string; status?: string}>(
  "adminUsers/getAll",
  async (data: string | {token: string; searchParam?: string; status?: string}) => {
    const token = typeof data === "string" ? data : data.token;
    const query = typeof data === "string" ? "" : buildQuery({searchParam: data.searchParam, status: data.status});
    return adminRequest(`/users${query}`, {token});
  }
);

export const getAdminPermissions = createAsyncThunk<any[], string>(
  "adminUsers/getPermissions",
  async (token: string) => adminRequest("/permissions", {token})
);

export const createAdminUser = createAsyncThunk<any, {token: string; email: string; firstName?: string; lastName?: string; password: string; permissions: string[]}>(
  "adminUsers/create",
  async (data: {token: string; email: string; firstName?: string; lastName?: string; password: string; permissions: string[]}) =>
    adminRequest("/users", {
      method: "POST",
      token: data.token,
      body: JSON.stringify(data),
    })
);

export const updateAdminUserPermissions = createAsyncThunk<any, {token: string; userId: string; permissions: string[]}>(
  "adminUsers/updatePermissions",
  async (data: {token: string; userId: string; permissions: string[]}) =>
    adminRequest(`/users/${data.userId}/permissions`, {
      method: "PUT",
      token: data.token,
      body: JSON.stringify({permissions: data.permissions}),
    })
);

const adminUserSlice = createSlice({
  name: "adminUsers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = (action.payload as any[]).map((item: any) => ({...item, key: item.id}));
      })
      .addCase(getAdminPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.permissions = action.payload as any[];
      })
      .addCase(createAdminUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users = [{...(action.payload as any), key: (action.payload as any).id}, ...state.users];
      })
      .addCase(updateAdminUserPermissions.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload as any;
        state.users = state.users.map((user) => user.id === updated.id ? {...updated, key: updated.id} : user);
      })
      .addMatcher(
        (action) => action.type.startsWith("adminUsers/") && action.type.endsWith("/pending"),
        (state) => {
          state.loading = true;
          state.error = undefined;
        }
      )
      .addMatcher(
        (action) => action.type.startsWith("adminUsers/") && action.type.endsWith("/rejected"),
        (state, action: any) => {
          state.loading = false;
          state.error = action.error?.message;
        }
      );
  },
});

export default adminUserSlice.reducer;
